<template>
  <div class="home">
    <!-- tab标签页 -->
    <div class="tabs-wrap">
      <div class="tabs-item" @click="tabs_index = 1">
        <div :class="{ 'item-text': true, 'item-text__act': tabs_index == 1 }">联系客服</div>
        <div class="item-line"></div>
      </div>
      <div class="tabs-item" v-if="app_cond.refund" @click="tabs_index = 2">
        <div :class="{ 'item-text': true, 'item-text__act': tabs_index == 2 }">退款申诉</div>
        <div class="item-line"></div>
      </div>
      <div :class="{ line__def: true, line__act: tabs_index == 2 }"></div>
    </div>

    <!-- 联系客服 -->
    <div class="content-wrap" v-if="tabs_index == 1">
      <div class="lable3 text2">问题描述<span style="opacity: 0">102</span></div>
      <div class="input1">
        <van-field v-model="chat_form.reason" rows="4" type="textarea" maxlength="200" placeholder="请填写10个字以上的问题描述，以便我们为您提供更好的服务" @paste.prevent @paste="preventPaste" />
        <div :class="{ count: true, count__over: chat_form.reason.length > 200 }">{{ chat_form.reason.length }}<span>/字</span></div>
      </div>
      <div class="lable2 text2">联系电话</div>
      <div class="input2">
        <van-field :class="{ readonly: chat_form.is_lock }" v-model="chat_form.phone" maxlength="11" :readonly="chat_form.is_lock" placeholder="请填写手机号" @paste.prevent @paste="preventPaste" />
      </div>
      <!-- <div class="tips" v-if="ischannel">在线客服请拨打：4001666606</div> -->
      <div class="submit-btn" @click="handleSubmitForm(1)">提交反馈</div>
    </div>

    <!-- 退款申诉 -->
    <div class="content-wrap" v-if="tabs_index == 2">
      <div class="text1 part1">HI！亲爱的 {{ refund_form.phone }}</div>
      <div class="text2 part2">感谢您订阅超级VIP会员！</div>
      <div class="text1 part3">根据<span style="color: #ee4747; text-decoration: underline" @click="handleLookAgreement()">《自动订阅协议》</span>的约定内容，本产品为虚拟电子商品，一经售出，概不支持退款。</div>
      <div class="text1 part4">如果您仍有特殊情况需要申请退款，请如实填写以下信息，我们将会进行评估。</div>
      <div class="lable1">
        <div class="text2">退款理由</div>
        <div class="lable1-btn" @click="handleGoQuestion()">我为什么被扣款 <img src="https://bcloud.aitici.com/aipaintingdouying/image/20230323/bb928a007d3d0dbf9e907759647c69cc.png" alt="" /></div>
      </div>
      <div class="input1">
        <van-field v-model="refund_form.reason" rows="4" type="textarea" maxlength="200" placeholder="请描述您的退款理由，越详细越有助于客服核实与处理退款申请" @paste.prevent @paste="preventPaste" />
        <div :class="{ count: true, count__over: refund_form.reason.length > 200 }">{{ refund_form.reason.length }}<span>/字</span></div>
      </div>
      <div class="lable2 text2">联系电话</div>
      <div class="input2">
        <van-field :class="{ readonly: refund_form.is_lock }" v-model="refund_form.phone" maxlength="11" :readonly="refund_form.is_lock" placeholder="请填写手机号" @paste.prevent @paste="preventPaste" />
      </div>

      <div class="submit-btn" @click="handleSubmitForm(2)">提交反馈</div>
    </div>

    <!-- 弹出提示窗 -->
    <div class="popup-wrap" v-show="popup_flag == 1" @click="popup_flag = 0">
      <div class="tip-text">您还未填写退款理由</div>
    </div>
    <div class="popup-wrap" v-show="popup_flag == 2" @click="popup_flag = 0">
      <div class="tip-text">您还未填写联系电话</div>
    </div>
    <div class="popup-wrap" v-show="popup_flag == 3" @click="popup_flag = 0">
      <div class="tip-text">请补充您的退款理由，不得少于10个字</div>
    </div>
    <div class="popup-wrap" v-show="popup_flag == 4" @click="popup_flag = 0">
      <div class="tip-text">请检查您的联系电话，要求11位</div>
    </div>
    <div class="popup-wrap" v-show="popup_flag == 5" @click="popup_flag = 0">
      <div class="tip-text">已收到您的反馈，请等待客服人员处理</div>
    </div>
    <div class="popup-wrap" v-show="popup_flag == 6" @click="popup_flag = 0">
      <div class="tip-text">您还未填写问题描述</div>
    </div>

    <div class="popup-wrap" v-show="popup_flag == 7" @click="popup_flag = 0">
      <div class="tip-text">请补充您的问题描述，不得少于10个字</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeView',
  data() {
    return {
      ischannel: false,
      tabs_index: 1,
      popup_flag: 0,
      refund_form: {
        reason: '',
        phone: '',
        is_lock: false,
        is_submit: false,
      },
      chat_form: {
        reason: '',
        phone: '',
        is_lock: false,
        is_submit: false,
      },
      app_cond: {
        refund: false,
        host: '',
        token: '',
        phone: '',
        version_code: '',
      },
      gid1: '483193481',
      gid2: '482709491',
    };
  },
  created() {
    /**
     * 需要APP端传递的参数
     * refund Boolean true-开启退款申诉入口；false-关闭退款申诉入口
     * host String 上报域名
     * token String 用户token
     * phone String 用户联系方式
     */
    // 获取APP客户端传参
    this.app_cond.refund = this.$route.query.refund == 'true' ? true : false;
    this.app_cond.host = this.$route.query.host;
    this.app_cond.token = this.$route.query.token;
    this.app_cond.phone = this.$route.query.phone;
    this.app_cond.version_code = this.$route.query.version_code;
    this.refund_form.phone = this.$route.query.phone;
    this.chat_form.phone = this.$route.query.phone;
    console.log('APP端传参', this.app_cond);
    if (this.app_cond.refund) {
      this.tabs_index = 2;
    }
    if (this.refund_form.phone && this.refund_form.phone.length == 11) {
      this.refund_form.is_lock = true;
    }
    if (this.chat_form.phone && this.chat_form.phone.length == 11) {
      this.chat_form.is_lock = true;
    }
    // this.getMemberInfo();
    this.getQyIMGid();
  },
  methods: {
    //得到七鱼IM客服组id
    async getQyIMGid() {
      let cond = `url=http://test776.aitici.com/index.php/index/Sevenfish/sevenfishList&is_post=0`;
      let res = await this.$axios.post(`https://complaint-service.aitici.com/index/index/zhuanfa`, cond, {
        headers: {
          'content-type': 'application/x-www-form-urlencoded',
        },
      });
      console.log('客户分组', res.data.data);
      if (res.data.data.code == 200) {
        if (this.tabs_index == 1) {
          res.data.data.data.forEach((item, index) => {
            if (item.type == 1) {
              this.gid1 = item.sdk_id;
            }
          });
        } else if (this.tabs_index == 2) {
          res.data.data.data.forEach((item, index) => {
            if (item.type == 2) {
              this.gid2 = item.sdk_id;
            }
          });
        }
      }
    },
    //得到会员渠道号
    async getMemberInfo() {
      const url = `http://middlegrounpcomplaint.juzan.info/api/member/info?host_number=${this.app_cond.host}`;
      const config = {
        method: 'GET',
        headers: {
          token: this.app_cond.token,
        },
      };
      try {
        const resp = await fetch(url, config);
        let data = await resp.json();
        console.log('渠道信息', data);
        if (data.code == 1) {
          if (data.data.channel == 'huawei' || data.data.channel == 'oppo' || data.data.channel == 'xiaomi' || data.data.channel == 'vivo') {
            this.ischannel = true;
          }
        } else {
          console.log(data);
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 禁止粘贴
    preventPaste() {
      this.$toast('此处不能粘贴');
    },
    // 我为啥会被扣款
    handleGoQuestion() {
      this.$router.push('./question');
    },
    // 查看《自动订阅协议》
    handleLookAgreement() {
      // this.$router.push('./agreement');
      // 跳自动订阅协议页面
      // window.location= `${this.app_cond.host}/subscribeagreement`;
      this.$bridge.callhandler('handleJumpAgreement', {}, (data) => {
        console.log('调用成功啦');
      });
    },
    // 提交表单
    async handleSubmitForm(flag) {
      // flag==1为联系客服；flag==2为退款申诉
      if (flag == 1) {
        if (!this.chat_form.reason) {
          this.popup_flag = 6;
          return;
        }

        if (!this.chat_form.phone) {
          this.popup_flag = 2;
          return;
        }

        if (this.chat_form.reason.length < 10) {
          this.popup_flag = 7;
          return;
        }

        if (this.chat_form.phone.length != 11) {
          this.popup_flag = 4;
          return;
        }

        // 增加节流
        if (this.chat_form.is_submit) {
          return;
        }
        this.chat_form.is_submit = true;

        // let cond = `token=${this.app_cond.token}&content=${this.chat_form.reason}&mobile=${this.chat_form.phone}&contact=""&host=${this.app_cond.host}`;
        // if(!this.chat_form.is_lock){
        //   cond = `token=${this.app_cond.token}&content=${this.chat_form.reason}&mobile=""&contact=${this.chat_form.phone}&host=${this.app_cond.host}`;
        // }

        // 修改传参形式和传参接口
        let cond = {
          token: this.app_cond.token,
          content: this.chat_form.reason,
          mobile: this.chat_form.phone,
          contact: '',
          host_number: this.app_cond.host,
          version_code: this.app_cond.version_code,
        };
        if (!this.chat_form.is_lock) {
          cond.contact = this.chat_form.phone;
          cond.mobile = '';
        }

        let res = await this.$axios.post(`http://middlegrounpcomplaint.juzan.info/app_feedback`, cond);
        console.log(res.data);

        if (res.data.code == 200) {
          // this.popup_flag = 5;
          this.chat_form.reason = '';
          //需要传给客户端的参数
          let params = {
            userMobile: this.chat_form.phone,
            refundReason: this.chat_form.reason,
            tabType: this.tabs_index,
            gid: this.gid1,
          };
          this.$bridge.callhandler('submitFeedbackSuc', params, (data) => {
            console.log('调用成功啦');
          });
        } else {
          this.$toast('请稍后重试');
          this.chat_form.is_submit = false;
        }
      } else if (flag == 2) {
        if (!this.refund_form.reason) {
          this.popup_flag = 1;
          return;
        }

        if (!this.refund_form.phone) {
          this.popup_flag = 2;
          return;
        }

        if (this.refund_form.reason.length < 10) {
          this.popup_flag = 3;
          return;
        }

        if (this.refund_form.phone.length != 11) {
          this.popup_flag = 4;
          return;
        }

        // 增加节流
        if (this.refund_form.is_submit) {
          return;
        }
        this.refund_form.is_submit = true;

        // let cond = `content=${this.refund_form.reason}&mobile=${this.refund_form.phone}`;

        // if(!this.refund_form.is_lock){
        //   cond = `content=${this.refund_form.reason}&mobile=""&w_mobile=${this.refund_form.phone}`;
        // }

        let cond = {
          token: this.app_cond.token,
          content: this.refund_form.reason,
          mobile: this.refund_form.phone,
          contact: '',
          host_number: this.app_cond.host,
          version_code: this.app_cond.version_code,
        };
        if (!this.refund_form.is_lock) {
          cond.contact = this.refund_form.phone;
          cond.mobile = '';
        }

        let res = await this.$axios.post(`http://middlegrounpcomplaint.juzan.info/app_complaint`, cond);
        console.log(res.data);
        if (res.data.code == 200) {
          // this.popup_flag = 5;
          this.refund_form.reason = '';
          //需要传给客户端的参数
          let params = {
            userMobile: this.refund_form.phone,
            refundReason: this.refund_form.reason,
            tabType: this.tabs_index,
            gid: this.gid2,
          };
          this.$bridge.callhandler('submitFeedbackSuc', params, (data) => {
            console.log('调用成功啦');
          });
        } else {
          this.$toast('请稍后重试');
          this.refund_form.is_submit = false;
        }
      }
    },
  },
};
</script>

<style lang="less">
.home {
  width: 750px;
  padding-bottom: 200px;
  min-height: calc(100vh - 200px);
  background: #f7f6fb;
}
// tab标签页
.tabs-wrap {
  position: relative;
  display: flex;
  width: 750px;
  height: 88px;
  background: #ffffff;
  .tabs-item {
    width: 50%;
    .item-text {
      margin-top: 24px;
      text-align: center;
      font-size: 32px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 40px;
    }
    .item-line {
      width: 100%;
      height: 2px;
      margin-top: 22px;
      background-color: rgba(0, 0, 0, 0.05);
    }
    .item-text__act {
      background: linear-gradient(135deg, #0579ee 0%, #14bfda 48%, #1fe9ca 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
  .line__def {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 50%;
    height: 4px;
    margin-top: 20px;
    background-color: #1de2cd;
    border-radius: 2px;
    transition: transform 0.5s ease;
  }
  .line__act {
    transform: translateX(100%);
  }
}

// 内容
.content-wrap {
  padding: 0 40px;
  .tips {
    margin-top: 30px;
    text-align: center;
    font-size: 24px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 48px;

    user-select: none; /* 禁止选择 */
    -moz-user-select: none; /* Firefox */
    -webkit-user-select: none; /* Safari 和 Chrome */
    -ms-user-select: none; /* IE10+ */
  }
  .text1 {
    font-size: 28px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 48px;
  }
  .text2 {
    font-size: 32px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 44px;
  }
  .part1 {
    margin-top: 28px;
  }
  .part2 {
    margin-top: 12px;
  }
  .part3 {
    margin-top: 24px;
  }
  .part4 {
    margin-top: 16px;
  }
  .lable1 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 50px;
    margin-top: 72px;
    .lable1-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 230px;
      height: 50px;
      background: linear-gradient(150deg, #1498ee 0%, #1de0ce 100%);
      border-radius: 70px;

      font-size: 24px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 34px;
      img {
        width: 24px;
        height: 24px;
        margin-left: 4px;
      }
    }
  }
  .input1 {
    position: relative;
    .van-field {
      width: 670px;
      height: 256px;
      padding: 24px 40px 24px 24px;
      margin-top: 20px;
      background: #ffffff;
      border-radius: 16px;

      font-size: 32px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 44px;
    }
    /* 修改Van-field中的placeholder样式 */
    .van-field__control::placeholder {
      font-size: 28px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 40px;
    }
    .count {
      position: absolute;
      bottom: 20px;
      right: 20px;
      font-size: 24px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #cccccc;
      line-height: 34px;
      span {
        font-size: 16px;
      }
    }
    .count__over {
      color: red;
    }
  }

  .lable2 {
    margin-top: 48px;
  }
  .input2 {
    .van-field {
      width: 670px;
      height: 92px;
      padding: 24px 40px 24px 24px;
      margin-top: 24px;
      background: #ffffff;
      border-radius: 16px;

      font-size: 32px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 44px;
    }
    /* 修改Van-field中的placeholder样式 */
    .van-field__control::placeholder {
      font-size: 28px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 40px;
    }
    .readonly {
      input {
        color: #999;
      }
    }
  }
  .lable3 {
    margin-top: 32px;
  }
  .submit-btn {
    position: fixed;
    bottom: 98px;
    left: 40px;
    width: 670px;
    height: 88px;
    background: linear-gradient(97deg, #0579ee 0%, #14bfda 48%, #1fe9ca 100%);
    border-radius: 44px;

    text-align: center;
    font-size: 32px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 88px;
  }
}
.popup-wrap {
  z-index: 99;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 0px 0px 0px 0px;
  .tip-text {
    background: rgba(0, 0, 0, 1);
    padding: 24px;
    border-radius: 24px 24px 24px 24px;

    font-size: 32px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 48px;
    opacity: 0.5;
  }
}
</style>
